import adultsEatingAtTable from 'images/2019-10-18/adults-eating-at-table.jpg'
import manSmilingWithBread from 'images/2019-10-18/man-smiling-with-bread.jpg'
import twoMenButteringRolls from 'images/2019-10-18/two-men-buttering-rolls.jpg'
import cupcakeLine from 'images/2017-11-4/cupcake-line.jpg'
import cupcakeLoaded from 'images/2017-11-4/cupcake-loaded.jpg'
import cupcakeMustache from 'images/2017-11-4/cupcake-mustache.jpg'
import ingredientsEagleEye from 'images/2017-11-4/ingredients-eagle-eye.jpg'
import kidChocCupcake from 'images/2017-11-4/kid-choc-cupcake.jpg'
import kidDecoratingCupcakeWithHelp from 'images/2017-11-4/kid-decorating-cupcake-with-help.jpg'
import kidDecoratingCupcake from 'images/2017-11-4/kid-decorating-cupcake.jpg'
import kidJuicingLemon from 'images/2017-11-4/kid-juicing-lemon.jpg'
import kidPeaceSignCupcake from 'images/2017-11-4/kid-peace-sign-cupcake.jpg'
import kidPeaceSignXmasTree from 'images/2017-11-4/kid-peace-sign-xmas-tree.jpg'
import kidPouringSaltInCup from 'images/2017-11-4/kid-pouring-salt-in-cup.jpg'
import kidPouringSprinkles from 'images/2017-11-4/kid-pouring-sprinkles.jpg'
import kidScoopingCookieDough from 'images/2017-11-4/kid-scooping-cookie-dough.jpg'
import kidSprinklingOnCupcake from 'images/2017-11-4/kid-sprinkling-on-cupcake.jpg'
import kidStirringIngredients from 'images/2017-11-4/kid-stirring-ingredients.jpg'
import kidsHandSqueezingFrosting from 'images/2017-11-4/kids-hand-squeezing-frosting.jpg'
import muffinsChocChipTower from 'images/2017-11-4/muffins-choc-chip-tower.jpg'
import pumpkinChocChipMuffinsInPan from 'images/2017-11-4/pumpkin-choc-chip-muffins-in-pan.jpg'
import twoKidsButter from 'images/2017-11-4/two-kids-butter.jpg'
import twoKidsChefHats from 'images/2017-11-4/two-kids-chef-hats.jpg'
import twoKidsStirringLaugh from 'images/2017-11-4/two-kids-stirring-laugh.jpg'
import twoKidsStirring from 'images/2017-11-4/two-kids-stirring.jpg'
import twoKidsWhiteBowl from 'images/2017-11-4/two-kids-white-bowl.jpg'
import babyBlocksFood from 'images/2020-06-06/baby-blocks-food.jpg'
import banquetTableMiscFood from 'images/2020-06-06/banquet-table-misc-food.jpg'
import banquetTablePretzelsTrianglePlates from 'images/2020-06-06/banquet-table-pretzels-triangle-plates.jpg'
import cakeAndOldBooks from 'images/2020-06-06/cake-and-old-books.jpg'
import dinnerTakesAll from 'images/2020-06-06/dinner-takes-all.jpg'
import frostSettingCakePops from 'images/2020-06-06/frost-setting-cake-pops.jpg'
import girlScoopingChocolateFinger from 'images/2020-06-06/girl-scooping-chocolate-finger.jpg'
import meatAndFruitLarge from 'images/2020-06-06/meat-and-fruit-large.jpg'
import meatAndFruit from 'images/2020-06-06/meat-and-fruit.jpg'
import twoKidsBigHats from 'images/2020-06-06/two-kids-big-hats.jpg'

export default [
  { src: babyBlocksFood, alt: '', title: '', caption: '' },
  { src: banquetTableMiscFood, alt: '', title: '', caption: '' },
  { src: banquetTablePretzelsTrianglePlates, alt: '', title: '', caption: '' },
  { src: cakeAndOldBooks, alt: '', title: '', caption: '' },
  { src: dinnerTakesAll, alt: '', title: '', caption: '' },
  { src: frostSettingCakePops, alt: '', title: '', caption: '' },
  { src: girlScoopingChocolateFinger, alt: '', title: '', caption: '' },
  { src: meatAndFruitLarge, alt: '', title: '', caption: '' },
  { src: meatAndFruit, alt: '', title: '', caption: '' },
  { src: twoKidsBigHats, alt: '', title: '', caption: '' },
  {
    src: adultsEatingAtTable,
    alt: '',
    title: '',
    caption: '',
  },
  {
    src: manSmilingWithBread,
    alt: '',
    title: '',
    caption: '',
  },
  {
    src: twoMenButteringRolls,
    alt: '',
    title: '',
    caption: '',
  },
  {
    src: cupcakeLine,
    alt: '',
    title: '',
    caption: '',
  },
  {
    src: cupcakeLoaded,
    alt: '',
    title: '',
    caption: '',
  },
  {
    src: cupcakeMustache,
    alt: '',
    title: '',
    caption: '',
  },
  {
    src: ingredientsEagleEye,
    alt: '',
    title: '',
    caption: '',
  },
  {
    src: kidChocCupcake,
    alt: '',
    title: '',
    caption: '',
  },
  {
    src: kidDecoratingCupcakeWithHelp,
    alt: '',
    title: '',
    caption: '',
  },
  {
    src: kidDecoratingCupcake,
    alt: '',
    title: '',
    caption: '',
  },
  {
    src: kidJuicingLemon,
    alt: '',
    title: '',
    caption: '',
  },
  {
    src: kidPeaceSignCupcake,
    alt: '',
    title: '',
    caption: '',
  },
  {
    src: kidPeaceSignXmasTree,
    alt: '',
    title: '',
    caption: '',
  },
  {
    src: kidPouringSaltInCup,
    alt: '',
    title: '',
    caption: '',
  },
  {
    src: kidPouringSprinkles,
    alt: '',
    title: '',
    caption: '',
  },
  {
    src: kidScoopingCookieDough,
    alt: '',
    title: '',
    caption: '',
  },
  {
    src: kidSprinklingOnCupcake,
    alt: '',
    title: '',
    caption: '',
  },
  {
    src: kidStirringIngredients,
    alt: '',
    title: '',
    caption: '',
  },
  {
    src: kidsHandSqueezingFrosting,
    alt: '',
    title: '',
    caption: '',
  },
  {
    src: muffinsChocChipTower,
    alt: '',
    title: '',
    caption: '',
  },
  {
    src: pumpkinChocChipMuffinsInPan,
    alt: '',
    title: '',
    caption: '',
  },
  {
    src: twoKidsButter,
    alt: '',
    title: '',
    caption: '',
  },
  {
    src: twoKidsChefHats,
    alt: '',
    title: '',
    caption: '',
  },
  {
    src: twoKidsStirringLaugh,
    alt: '',
    title: '',
    caption: '',
  },
  {
    src: twoKidsStirring,
    alt: '',
    title: '',
    caption: '',
  },
  {
    src: twoKidsWhiteBowl,
    alt: '',
    title: '',
    caption: '',
  },
]



// WEBPACK FOOTER //
// ./src/components/Gallery/GalleryImages.js